import { setPlayerState } from './playerstates';
import {
  NOT_PLAYING,
  PLAYING_LIVE_IP,
  PLAYING_LIVE_DVB,
  PLAYING_MP3,
  PLAYING_RADIO,
  PLAYING_VOD_DRM,
  PLAYING_VOD_CLEAR,
  SHOWING_IMAGE
  } from './../utils/playerConstants';

import PlayerStates from './../utils/PlayerStates';
import PlayerStreamingUtils from 'src/utils/PlayerStreamingUtils';
import { LetsPlayCatchup } from 'src/components/PersistentMiniEpg/MiniObserver';
import * as EpgEventUtils from 'src/components/Epg/EpgEventUtils';
import { AAFPLAYER_PLAY } from 'src/AAFPlayer/constants';
import { AAF_MODAL_ERROR, showModal } from './modal';
import Translator from 'src/requests/apa/Translator';
import Utils from 'src/utils/Utils';
import AAF from 'src/AAF/AAF'
import logger from 'src/utils/logger/logger';

// Play video
export const PLAY_FULL_MEDIA = 'PLAY_FULL_MEDIA';
export const PLAY_PIP_MEDIA = 'PLAY_PIP_MEDIA';
export const HIDE_PIP_MEDIA = 'HIDE_PIP_MEDIA';
export const IS_ENDING = 'IS_ENDING';

export const RESIZE_FULL_MEDIA = 'RESIZE_FULL_MEDIA';
export const REPLACE_FULL_SOURCE_MEDIA = 'REPLACE_FULL_SOURCE_MEDIA';
export const REPLACE_PIP_SOURCE_MEDIA = 'REPLACE_PIP_SOURCE_MEDIA';

/*
 @param
  newSource = {
    src: , // new url to replace current and play
    drmInfo: {}, // DRM info if apply
    streamType: , // see playerConstants
    isLive: , // must be true at this moment
    resume: ,
  }
*/
export const replaceFullSourceMedia = (newSource) => (dispatch) => {
  let resp = dispatch({
    newSource,
    type: REPLACE_FULL_SOURCE_MEDIA,
  });
}

export const replacePipSourceMedia = (newSource) => (dispatch) => {
  let resp = dispatch({
    newSource,
    type: REPLACE_PIP_SOURCE_MEDIA,
  });
}

// Nagra performance, live and DVBC
export const resizeFullMedia = (size) => (dispatch) => {
  let res1 = dispatch({
    size,
    type: RESIZE_FULL_MEDIA,
  });
}

export const playFullMedia = (pgm) => (dispatch, getState) => {

  return  dispatch({
    pgm,
    type: PLAY_FULL_MEDIA,
  });

  // Verificamos si el state es el mismo entons nada que hacer, nada que settear...
  // Get a real copy

  let currentState = JSON.parse(JSON.stringify(getState().playerstates));
  logger.debug('[CURRENT PLAYER STATE***] ' );
  logger.debug(currentState);

  // Set this player as FULL
  pgm.ispip = false;
  pgm.size = null;
  pgm.newSource = null;
  let res1 = dispatch({
    pgm,
    type: PLAY_FULL_MEDIA,
  });

  // Resolve next state based on pgm params
  let nextPlayerInfo = {
    isFull: true,
    internalState: NOT_PLAYING
  }
  logger.debug('[NEXT PLAYER INFO]', getState().playerstates, nextPlayerInfo);
  let nextPlayerState = PlayerStates.resolveNextPlayerState(pgm, getState().playerstates, nextPlayerInfo);
  logger.debug('[CURRENT PLAYER STATE] before play new content' );
  logger.debug(currentState);
  logger.debug('[NEXT PLAYER STATE] while playing...');

  let sendNewState = false;
  if(currentState.singlefullplayerstate.currentstate !== nextPlayerState.singlefullplayerstate.currentstate) {
    sendNewState = true;
  }
  if(currentState.currentplayersstate !== nextPlayerState.currentplayersstate) {
    sendNewState = true;
  }

  let doforcefullstop = false;
  let doforcepipstop = false;
  if(sendNewState) {
    logger.debug('[ALREADY CHANGE STATE]');
    doforcefullstop = nextPlayerState.forcefullstop;
    doforcepipstop = nextPlayerState.forcepipstop;
    delete nextPlayerState.forcefullstop;
    delete nextPlayerState.forcepipstop;
    dispatch(setPlayerState(nextPlayerState));
  }

  // Check for force stop players ?¿??¿?¿? IMPORTANT: dont move this code, must be at the end of this dispatch method
  // because if we need to force stop on player, we must do it after dispatch the player state above
  if(doforcefullstop) {
    logger.error('[SET PLAYER STATE] Player state changed from FULL PLAYER but maybe in unknown state...need to force full player to stop?');
    /*
    setTimeout(() => {
      dispatch(playFullMedia({src: null}));
    }, 1500);
    */
  }
  if(doforcepipstop) {
    logger.error('[SET PLAYER STATE] Player state changed from FULL PLAYER but maybe in unknown state...need to force pip player to stop?');
    /*
    setTimeout(() => {
      dispatch(playPipMedia({src: null}));
    }, 1500);
    */
  }
}

export const playPipMedia = (playerProps) => (dispatch, getState) => {
  // Verificamos si el state es el mismo entons nada que hacer, nada que settear...
  // Get a real copy
  let currentState = JSON.parse(JSON.stringify(getState().playerstates));

  // Set this player as PIP
  playerProps.ispip = true;
  playerProps.size = null;
  playerProps.newSource = null;

  dispatch({
    playerProps,
    type: PLAY_PIP_MEDIA,
  });

  let nextPlayerInfo = {
    isFull: false,
    internalState: NOT_PLAYING
  }
  let nextPlayerState = PlayerStates.resolveNextPlayerState(playerProps, getState().playerstates, nextPlayerInfo);
  logger.debug('[STATE PIP VIDEO] nextPlayerState: ');
  logger.info(nextPlayerState);

  let sendNewState = false;
  if(currentState.singlepipplayerstate.currentstate !== nextPlayerState.singlepipplayerstate.currentstate) {
    sendNewState = true;
  }
  if(currentState.currentplayersstate !== nextPlayerState.currentplayersstate) {
    sendNewState = true;
  }

  let doforcefullstop = false;
  let doforcepipstop = false;
  if(sendNewState) {
    doforcefullstop = nextPlayerState.forcefullstop;
    doforcepipstop = nextPlayerState.forcepipstop;
    delete nextPlayerState.forcefullstop;
    delete nextPlayerState.forcepipstop;
    dispatch(setPlayerState(nextPlayerState));
  }

  // Check for force stop players ?¿??¿?¿? IMPORTANT: dont move this code, must be at the end of this dispatch method
  // because if we need to force stop on player, we must do it after dispatch the player state above
  if(doforcefullstop) {
    logger.error('[SET PLAYER STATE] Player state changed from PIP PLAYER but maybe in unknown state...need to force full player to stop?');
    /*
    setTimeout(() => {
      dispatch(playFullMedia({src: null}));
    }, 1500);
    */
  }
  if(doforcepipstop) {
    logger.error('[SET PLAYER STATE] Player state changed from PIP PLAYER but maybe in unknown state...need to force pip player to stop?');
    /*
    setTimeout(() => {
      dispatch(playPipMedia({src: null}));
    }, 1500);
    */
  }
}

export const hidePipMedia = () => dispatch => {
  dispatch({
    type: HIDE_PIP_MEDIA,
  });
}

export const isEnding = () => ({ type: IS_ENDING, isEnding: true });
/*
  Example of object to play VOD DRM:
  {
    "src":"http://mirrors.standaloneinstaller.com/video-sample/jellyfish-25-mbps-hd-hevc.mp4",
    "controls":true,
    "muted":false,
    "drmInfo":{
      "server_url":"https://playready-vod-sony.clarovideo.net/rightsmanager.asmx",
      "challenge":"{\"token\":\"0a7ae4b06d2adc69f1eb01a04fa88b9b\",\"material_id\":\"1936780\"}",
      "content_id":"737932",
      "device_id":"e750e65c-09de-1a37-96f8-1378a1bd297e"
    },
    "autoPlay":true,
    "isLive":false,
    "streamType":"smooth_streaming",
    "resume":0,
    "backgroundImage":"https://clarovideocdn3-a.akamaihd.net/PELICULAS/MUMMYTHE2017/EXPORTACION_WEB/CLEAN/MUMMYTHE2017_e-1280x720.jpg",
    "isTrailer":true,
    "creditsTime":"-15"}
   */

export const playCatchupEvent = (event = {}, isRestart = false) => dispatch => {
  const groupId = event.channel_group_id || event.group_id;
    const playerStreamingUtils = new PlayerStreamingUtils();
    LetsPlayCatchup.fire();
    const canTimeShift = EpgEventUtils.canTimeShift(event);
    // canTimeShift debe ser siempre un unix
    const dateBegin = canTimeShift ? canTimeShift : event.date_begin;
    const dateEnd = event.date_end;
    const begin = isRestart ? dateBegin : '';
    const end = !isRestart ? dateEnd : '';
    // Puede ser timeshift o puede ser catchup
    // Timeshift
    if (isRestart && begin) {
            // Esta dentro del rango actual del canal de timeshift?
        const timeshiftByChannel = playerStreamingUtils.getStarttimeTimeshift(groupId);
        const diff = new Date(begin).getTime() / 1000 - timeshiftByChannel.unix();
        // Diff en segundos, esta el evento en el seek
        if (diff >= 0) {
            const maxtimeshiftallowed = playerStreamingUtils.getMaxTimeshiftAllowed(groupId);
            // Si esta dentro del rango, se hace timeshift
            const seektime = new Date(begin).getTime() / 1000 - timeshiftByChannel.unix();
            if (seektime >= 0) {
                const timeshiftData = {
                    backward: true,
                    seektime,
                    maxtimeshiftallowed,
                    starttime: timeshiftByChannel.unix(),
                    // Para actualizar la barra de progreso
                    startprogressbar: seektime
                };
                const tparams = {
                    playerstate: AAFPLAYER_PLAY,
                    source: {
                        videoid: groupId
                    },
                    size: {
                        top: 0,
                        left: 0,
                        width: 1280,
                        height: 720
                    },
                    ispreview: false,
                    islive: true,
                    ispip: false,
                    filterTV: null,
                    timeshiftData,
                    //starttime: timeshiftByChannel.format("YYYY/MM/DD hh:mm:ss")
                    starttime: timeshiftByChannel.unix(),
                    event: null
                };
                dispatch(playFullMedia(tparams));
            }
        }
    }
    else if (end) {
        logger.debug('-----------------------------CTUP dispatch event dateBegin: ' + dateBegin);
        logger.debug('-----------------------------CTUP dispatch event dateEnd: ' + end);
        const beginUnix = dateBegin;
        const endUnix = end;
        // Filter params to adjust to availableTimeshift
        const eventDates = AAF.Timeshift.replaceCatchupTime(groupId, beginUnix, endUnix);
        if (eventDates) {
            const cparams = {
                playerstate: AAFPLAYER_PLAY,
                source: {
                    videoid: groupId
                },
                size: {
                    top: 0,
                    left: 0,
                    width: 1280,
                    height: 720
                },
                ispreview: false,
                islive: false,
                ispip: false,
                starttime: eventDates.startTime,
                endtime: eventDates.endTime,
                event: event
            };
            dispatch(playFullMedia(cparams));
        } else {
            const modal = {
                modalType: AAF_MODAL_ERROR,
                modalProps: {
                    callback : () => {},
                    content: { message: Translator.get(
                        'event_is_not_catchup',
                        'Evento no está disponible (Evento no es catchup)'
                        )
                    }
                }
            };
            dispatch(showModal(modal));
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/playmedia.js